import onHomeLogo from "@/images/logo/onhome.svg";
import TransitionLink from "./TransitionLink";
import { siteNavLinks } from "./site/nav";

interface FooterLink {
  to: string;
  label: string;
}

const quickLinks: FooterLink[] = [...siteNavLinks, { to: "/contact-us", label: "Get in touch" }];

const legalLinks: FooterLink[] = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-use", label: "Terms of Use" },
];

const FooterColumn = ({ title, links }: { title: string; links: FooterLink[] }) => {
  return (
    <div>
      <h2 className="text-sm font-semibold text-navy">{title}</h2>
      <ul className="mt-4 space-y-2.5">
        {links.map((link) => (
          <li key={link.to}>
            <TransitionLink to={link.to} className="text-sm text-slate-600 transition-colors hover:text-navy">
              {link.label}
            </TransitionLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Footer = () => {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="mx-auto max-w-[1200px] px-5 py-14 sm:px-8">
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-[1.6fr_1fr_1fr]">
          <div className="sm:col-span-2 md:col-span-1">
            <img src={onHomeLogo} alt="OnHome" className="h-8 w-auto" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-600">
              Helping more Australians get into the homes they want, sooner.
            </p>
          </div>
          <FooterColumn title="Quick links" links={quickLinks} />
          <FooterColumn title="Legal" links={legalLinks} />
        </div>
        <div className="mt-12 flex flex-col gap-2 text-xs text-slate-500 sm:flex-row sm:justify-between">
          <p>&copy; {new Date().getFullYear()} OnHome Pty Ltd. All rights reserved.</p>
          <p>OnHome is the trading name for BuySooner.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
